import {
  Box,
  Container,
  Flex,
  Image,
  Center,
  Text,
  Avatar,
  Table,
  Tbody,
  Tr,
  Td,
  TableContainer,
  Link,
  Icon,
} from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import lp from "../assets/laptopguy.png";
import pasphoto from "../assets/pasphotoe.JPG";
import { BsBriefcase } from "react-icons/bs";
import { IoSchoolOutline } from "react-icons/io5";
import { PiLinkedinLogoLight } from "react-icons/pi";
import { VscGithubAlt } from "react-icons/vsc";
import { GrMysql } from "react-icons/gr";
import { BiLogoReact, BiLogoNodejs } from "react-icons/bi";
import { BsFiletypePdf } from "react-icons/bs";
import { SiPostgresql, SiMongodb } from "react-icons/si";
import { FaLaravel } from "react-icons/fa";
import { RiExternalLinkLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
// import { LiaUniversitySolid } from "react-icons/lia";
// import resume from "../assets/CV Samdipro Nainggolan.pdf";

export default function HomePage() {
  const nav = useNavigate();

  return (
    <Box w={"100vw"} bgColor={"#fdfbf5"} padding={"1rem"}>
      <Box border={"1px solid black"}>
        <Container
          maxW={"1860px"}
          padding={{ base: "0 1rem", md: "0 2rem", lg: "0 3rem" }}
        >
          <Flex flexDir={"column"} gap={"1rem"}>
            <Navbar></Navbar>
            <Flex
              borderBottom={"1px solid black"}
              justifyContent={"center"}
              paddingBottom={"1rem"}
              id="home"
            >
              <Flex
                width={{ base: "100%", md: "50%" }}
                fontSize={"1.8rem"}
                alignItems={"center"}
                textAlign={"center"}
              >
                <Flex flexDir={"column"} justifyContent={"center"}>
                  <Text className="font-title">Full-Stack Web Developer</Text>
                  <Text fontSize={"smaller"} className="font-paragraph">
                    A software engineer driven by constant learning and a
                    passion for crafting user-centric web experiences, I thrive
                    on tackling complex challenges. Equipped with a solid
                    foundation in both front-end and back-end technologies.
                  </Text>
                </Flex>
              </Flex>
              <Center width={{ base: "0%", md: "50%" }}>
                <Flex
                  borderRadius={"1rem"}
                  display={{ base: "none", md: "flex" }}
                >
                  <Image borderRadius={"1rem"} src={lp} alt="Image" />
                </Flex>
              </Center>
            </Flex>
            <Flex
              flexDir={"column"}
              paddingBottom={"1rem"}
              borderBottom={"1.5px solid black"}
              id="stack"
            >
              <Flex
                flexDir={{ base: "column", md: "row" }}
                alignItems={"center"}
              >
                <Center
                  width={{ base: "100%", md: "20%" }}
                  borderRight={{ base: "none", md: "1.5px solid black" }}
                  display={"flex"}
                  flexDir={"column"}
                  gap={"0.5rem"}
                >
                  <Center
                    className="font-paragraph"
                    padding={"1rem"}
                    fontSize={"xl"}
                  >
                    TECH STACK
                  </Center>
                </Center>
                <Flex
                  padding={"1rem 1rem"}
                  gap={"3rem"}
                  flexWrap={"wrap"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  width={"80%"}
                >
                  <Flex flexDir={"column"} alignItems={"center"}>
                    <Icon
                      fontWeight={"light"}
                      as={BiLogoReact}
                      fontSize={"6xl"}
                    ></Icon>
                    <Text>React</Text>
                  </Flex>
                  <Flex flexDir={"column"} alignItems={"center"}>
                    <Icon as={BiLogoNodejs} fontSize={"6xl"}></Icon>
                    <Text>Node.js</Text>
                  </Flex>
                  <Flex flexDir={"column"}>
                    <Text fontSize={"4xl"}>express</Text>
                  </Flex>
                  <Flex flexDir={"column"} alignItems={"center"}>
                    <Icon as={FaLaravel} fontSize={"6xl"}></Icon>
                    <Text>Laravel</Text>
                  </Flex>
                  <Flex flexDir={"column"} alignItems={"center"}>
                    <Icon as={SiPostgresql} fontSize={"6xl"}></Icon>
                    <Text>PostgreSQL</Text>
                  </Flex>
                  <Flex flexDir={"column"} alignItems={"center"}>
                    <Icon fontSize={"6xl"} as={GrMysql}></Icon>
                    <Text>MySQL</Text>
                  </Flex>
                  <Flex flexDir={"column"} alignItems={"center"}>
                    <Icon as={SiMongodb} fontSize={"6xl"}></Icon>
                    <Text>MongoDB</Text>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
            <Flex flexDir={"column"} paddingBottom={"1rem"}>
              <Flex flexDir={{ base: "column", md: "row" }} gap={"0 1rem"}>
                <Center
                  width={{ base: "100%", md: "20%" }}
                  borderRight={{ base: "none", md: "1px solid black" }}
                  display={"flex"}
                  flexDir={"column"}
                  gap={"0.5rem"}
                  paddingRight={"1rem"}
                >
                  <Center
                    className="font-paragraph"
                    padding={"1rem"}
                    fontSize={"xl"}
                    id="profile"
                  >
                    PROFILE
                  </Center>
                  <Avatar
                    size={{ base: "xl", md: "2xl" }}
                    src={pasphoto}
                  ></Avatar>
                  <Flex flexDir={"column"} textAlign={"center"} gap={"0.5rem"}>
                    <Flex flexDir={"column"}>
                      <Text fontSize={"xl"} fontWeight={"semibold"}>
                        Samdipro Nainggolan
                      </Text>
                      <Flex
                        alignItems={"center"}
                        fontSize={{
                          base: "smaller",
                          md: "smaller",
                          lg: "smaller",
                        }}
                        gap={"0.2rem"}
                        justifyContent={"center"}
                      >
                        <Text>samdiprongl@gmail.com</Text>
                      </Flex>
                    </Flex>
                    <Flex
                      justifyContent={"center"}
                      gap={"1rem"}
                      fontSize={"xl"}
                    >
                      <Link
                        href="https://www.linkedin.com/in/samdipro-nainggolan"
                        target="_blank"
                        _hover={{ color: "#0077b5" }}
                      >
                        <Icon as={PiLinkedinLogoLight}></Icon>
                      </Link>

                      <Link
                        href="https://github.com/samdipro"
                        target="_blank"
                        _hover={{ opacity: "0.8" }}
                      >
                        <Icon as={VscGithubAlt}></Icon>
                      </Link>
                    </Flex>
                  </Flex>
                </Center>
                <Flex
                  width={{ base: "100%", md: "80%" }}
                  padding={"0 1rem"}
                  className="font-paragraph"
                  fontSize={"xl"}
                  justifyContent={"center"}
                >
                  <TableContainer width={"100%"}>
                    <Table variant="simple">
                      <Tbody>
                        <Tr>
                          <Td display={{ base: "none", md: "flex" }}>
                            <Flex alignItems={"center"} gap={"0.2rem"}>
                              <Icon as={BsBriefcase}></Icon>
                              <Text>Experience</Text>
                            </Flex>
                          </Td>
                          <Td>
                            <Flex flexDir={"column"} gap={"1rem"}>
                              <Flex flexDir={"column"} gap={"0.4rem"}>
                                <Flex
                                  alignItems={"center"}
                                  gap={"0.2rem"}
                                  fontWeight={"bolder"}
                                >
                                  <Text>Software Engineer</Text>
                                </Flex>
                                <Flex gap={"0.2rem"}>
                                  <Text>PT MRT Jakarta</Text>
                                  <Text>-</Text>
                                  <Text color={"gray"}>Jakarta, Indonesia</Text>
                                </Flex>
                                <Flex fontSize={"smaller"}>
                                  Feb 2024 - Present
                                </Flex>
                              </Flex>
                              <Flex flexDir={"column"} gap={"0.4rem"}>
                                <Flex
                                  alignItems={"center"}
                                  gap={"0.2rem"}
                                  fontWeight={"bolder"}
                                >
                                  <Text>Full-stack Developer Intern</Text>
                                </Flex>
                                <Flex gap={"0.2rem"}>
                                  <Text>Iyagi</Text>
                                  <Text>-</Text>
                                  <Text color={"gray"}>Jakarta, Indonesia</Text>
                                </Flex>
                                <Flex fontSize={"smaller"}>
                                  Oct 2023 - Jan 2024
                                </Flex>
                              </Flex>
                              <Flex flexDir={"column"} gap={"0.4rem"}>
                                <Flex
                                  alignItems={"center"}
                                  gap={"0.2rem"}
                                  fontWeight={"bolder"}
                                >
                                  <Text>Research Assistant</Text>
                                </Flex>
                                <Flex gap={"0.2rem"}>
                                  <Text>Indonesian Institute of Sciences</Text>
                                  <Text>-</Text>
                                  <Text color={"gray"}>Bandung, Indonesia</Text>
                                </Flex>
                                <Flex fontSize={"smaller"}>
                                  Jun 2020 - Aug 2020
                                </Flex>
                              </Flex>
                              <Flex flexDir={"column"} gap={"0.4rem"}>
                                <Flex
                                  alignItems={"center"}
                                  gap={"0.2rem"}
                                  fontWeight={"bolder"}
                                >
                                  <Text>Intern</Text>
                                </Flex>
                                <Flex gap={"0.2rem"}>
                                  <Text>PT Telkom</Text>
                                  <Text>-</Text>
                                  <Text color={"gray"}>Medan, Indonesia</Text>
                                </Flex>
                                <Flex fontSize={"smaller"}>
                                  Jun 2019 - Aug 2019
                                </Flex>
                              </Flex>
                            </Flex>
                          </Td>
                        </Tr>
                        <Tr>
                          <Td display={{ base: "none", md: "flex" }}>
                            <Flex alignItems={"center"} gap={"0.2rem"}>
                              <Icon as={IoSchoolOutline}></Icon>
                              <Text>Education</Text>
                            </Flex>
                          </Td>
                          <Td>
                            <Flex flexDir={"column"} gap={"1rem"}>
                              <Flex flexDir={"column"} gap={"0.4rem"}>
                                <Flex
                                  alignItems={"center"}
                                  gap={"0.2rem"}
                                  fontWeight={"bolder"}
                                >
                                  <Text>
                                    Full-stack Web Development Bootcamp
                                  </Text>
                                </Flex>
                                <Flex gap={"0.2rem"}>
                                  <Text>
                                    Purwadhika Digital Technology School
                                  </Text>
                                  <Text>-</Text>
                                  <Text color={"gray"}>Batam, Indonesia</Text>
                                </Flex>
                                <Flex fontSize={"smaller"}>
                                  March 2023 - Sept 2023
                                </Flex>
                              </Flex>
                              <Flex flexDir={"column"} gap={"0.4rem"}>
                                <Flex alignItems={"center"} gap={"0.2rem"}>
                                  {/* <Icon as={LiaUniversitySolid}></Icon> */}
                                  <Text fontWeight={"bolder"}>
                                    Telkom University
                                  </Text>
                                  <Text>-</Text>
                                  <Text color={"gray"}>Bandung, Indonesia</Text>
                                </Flex>
                                <Text>
                                  Bachelor Degree in Engineering Physics
                                </Text>
                                <Flex fontSize={"smaller"}>
                                  Aug 2016 - Feb 2022
                                </Flex>
                              </Flex>
                            </Flex>
                          </Td>
                        </Tr>
                        <Tr>
                          <Td display={{ base: "none", md: "flex" }}>
                            <Flex alignItems={"center"} gap={"0.2rem"}>
                              <Icon as={BsFiletypePdf}></Icon>
                              <Text>Resume</Text>
                            </Flex>
                          </Td>
                          <Td>
                            <Link
                              // href={resume}
                              onClick={() => nav("/holdingpage")}
                              target="_blank"
                              _hover={{ color: "blue" }}
                            >
                              <Flex
                                textDecor={"underline"}
                                alignItems={"center"}
                              >
                                Resume<Icon as={RiExternalLinkLine}></Icon>
                              </Flex>
                            </Link>
                          </Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Container>
      </Box>
    </Box>
  );
}
